import {createGlobalStyle} from 'styled-components';

import {getColor} from './utils';

export const GlobalStyle = createGlobalStyle`
  /*
    Css reset
    https://www.joshwcomeau.com/css/custom-css-reset/
  */

  /*
    1. Use a more-intuitive box-sizing model.
  */
  *, *::before, *::after {
    box-sizing: border-box;
  }

  /*
    2. Remove default margin
  */
  * {
    margin: 0;
  }

  /*
    3. Allow percentage-based heights in the application
  */
  html, body {
    height: 100%;
  }

  /*
    Typographic tweaks!
    4. Add accessible line-height
    5. Improve text rendering
  */
  body {
    line-height: 1.5;
    -webkit-font-smoothing: antialiased;
    background-color: ${getColor('background1')};
    font-family: "Open Sans", system-ui, sans-serif;
  }

  /*
    6. Improve media defaults
  */
  img, picture, video, canvas, svg {
    display: block;
    max-width: 100%;
  }

  /*
    7. Remove built-in form typography styles
  */
  input, button, textarea, select {
    font: inherit;
  }

  /*
    8. Avoid text overflows
  */
  p, h1, h2, h3, h4, h5, h6 {
    overflow-wrap: anywhere;
  }

  /*
    9. Create a root stacking context
  */
  #root, #__next {
    isolation: isolate;
  }

  /*
    10. Centering button content (for example text + icon)
   */
  button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  .grecaptcha-badge {
    display: none !important;
  }
`;
